import React, { useState, useEffect } from 'react';
import './HomeBanner.css';
import { useNavigate } from 'react-router-dom';

const HomeBanner = () => {

    const navigate = useNavigate();
    const slides = [
        {
            title: "Transform Your Business",
            subtitle: "Software Development",
            description: "Cutting-edge technology solutions that drive growth and efficiency for your enterprise",
        },
        {
            title: "Scale with Confidence",
            subtitle: "Digital Markeing",
            description: "Robust, scalable systems designed to meet tomorrow's business challenges",
        },
        {
            title: "State-of-the-Art Visual Design",
            subtitle: "Graphic Design",
            description: "Innovative and captivating designs that elevate your brand and captivate your audience.",
        }

    ];

    const [currentSlide, setCurrentSlide] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(true);
            setTimeout(() => {
                setCurrentSlide((prev) => (prev + 1) % slides.length);
                setFade(false);
            }, 500);
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const currentVideo = slides[currentSlide];

    return (
        <div className="hero-banner-modern">
            <div className="video-container">
                <div class="video-container">
                    <iframe
                        src="https://www.youtube.com/embed/s9xk77X4m5c?autoplay=1&mute=1&loop=1&playlist=s9xk77X4m5c"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                    </iframe>
                </div>


                <div className="gradient-overlay"></div>
            </div>

            <div className={`hero-content-modern ${fade ? 'fade-out' : 'fade-in'}`}>
                <div className="content-wrapper">
                    <span className="subtitle-tag">{currentVideo.subtitle}</span>
                    <h1>{currentVideo.title}</h1>
                    <p>{currentVideo.description}</p>
                    <div className="button-group">
                        <button onClick={() => navigate('/contact-us')} className="cta-button-primary">Get Started</button>
                        <button onClick={() => navigate('/services')} className="cta-button-secondary">Learn More</button>
                    </div>
                </div>
            </div>

            <div className="slide-indicators-modern">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator-modern ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => {
                            setFade(true);
                            setTimeout(() => {
                                setCurrentSlide(index);
                                setFade(false);
                            }, 500);
                        }}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default HomeBanner;